/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_SUPPORT_RECEIVE,
    CURRENT_SUPPORT_REQUEST,
    CURRENT_SUPPORT_REQUEST_SUCCESS,
    CURRENT_SUPPORT_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_SUPPORT_REQUEST]: () => true,
    [CURRENT_SUPPORT_REQUEST_SUCCESS]: () => false,
    [CURRENT_SUPPORT_REQUEST_FAILURE]: () => false,
});

const id = createReducer(null, {
    [CURRENT_SUPPORT_RECEIVE]: (state, action) => action.payload.support.id,
});

export const error = createReducer(false, {
    [CURRENT_SUPPORT_REQUEST]: () => false,
    [CURRENT_SUPPORT_REQUEST_SUCCESS]: () => false,
    [CURRENT_SUPPORT_REQUEST_FAILURE]: () => true,
});



export default combineReducers({
    id,
    requesting,
    error
});
